module.exports = __webpack_public_path__ + "img/logo-rbxsoft.e663ec04.svg";